export var isString = function (value) {
    return typeof value === 'string';
};
//# sourceMappingURL=isString.js.map